'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _functional = require('../utils/functional');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _class = function _class(el) {
  var _this = this;

  (0, _classCallCheck3.default)(this, _class);

  this.els = {
    el: el,
    button: (0, _functional.getElement)('.com-Terms_Button', { context: el }),
    body: (0, _functional.getElement)('.com-Terms_Content', { context: el })
  };

  this.els.button.addEventListener('click', function (e) {
    var isCurrentlyOpen = _this.els.body.getAttribute('aria-expanded') === 'true';

    if (isCurrentlyOpen) {
      _this.els.body.setAttribute('aria-expanded', 'false');
      _this.els.button.classList.remove('com-Terms_Button-active');
    } else {
      _this.els.body.setAttribute('aria-expanded', 'true');
      _this.els.button.classList.add('com-Terms_Button-active');
    }
  });
};

exports.default = _class;